
 /*
    Author: Srinivas P
    Date: 11/12/2019
    Issue Description: Added signout functionality and style for getting sign-out popup
    Serach-String:PL-2290
*/

/*
    Author: Vinod
    Date: 04/02/2020
    Issue Description: Unable to click on Paylief logo.
    Serach-String:PL_2281
*/

/*
    Author: Vinod
    Date: 13/03/2020
    Issue Description: Sign out not working in Payroll Wizard.
    Serach-String:PL_2935
*/
<template>
  <div>
    <v-toolbar flat class="toolbar">
      <v-menu>
        <v-toolbar-title class="green-title" slot="activator">
          <!-- PL_2281 -->
          <span
            @click="$router.push(`/dashboard/${$route.params.entity_index}/payroll/monthlypayroll`)"
          >{{ brandName }}</span>
          <span class="toolbar-sub-text">{{ subText }}</span>
        </v-toolbar-title>
      </v-menu>
      <!-- <runpr-progressbar class="progress-bar" value="12"></runpr-progressbar> -->
      <div class="right-align"></div>
      <div class="links">
        <span class="cursor" @click="clickedOnImage()">
          <img src="@/assets/user@2x.png" class="img-user-account" />
          <div class="entity-container">
            <div class="btn-container2">
              <!-- <button class="btn-add-entity" @click="$router.push('/onboarding/legal_entities/addLegalEntity')">Add Legal Entity</button> -->
              <div class="btn-signout" @click="signout()">Signout</div>
            </div>
          </div>
        </span>
      </div>
    </v-toolbar>
    <pop-up-message
      v-if="showConfirmDelete"
      :message="'Are you sure want to Signout ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Signout'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="confirmSignout()">Signout</button>
        </div>
      </template>
    </pop-up-message>
  </div>
</template>

<script>
import RunprProgressbar from "./RunPRProgressbar.vue";
import { mapActions } from "vuex";  // PL_2935
export default {
  name: "RunPrToolbar",
  props: ["brandName", "subText"],
  components: {
    RunprProgressbar
  },
  data() {
    return {
      showEntitiesContainer: false,
      showConfirmDelete: false,
      popupType: "ConfirmDelete"
    };
  },
  methods: {
    ...mapActions({
      act_signOut: "auth/signOut" // PL_2935
    }),
    clickedOnImage() {
      //console.log("clickedOnImage:");
      this.showEntitiesContainer = !this.showEntitiesContainer;
    },
    cancelEvent() {
      this.showConfirmDelete = false;
    },
    signout() {
      this.showEntitiesContainer = !this.showEntitiesContainer;
      this.showConfirmDelete = true;
    },
    async confirmSignout() {
      try {
        let res = await this.act_signOut();
        //console.log("res", res);
        if (res.status == 200) {
          this.showConfirmDelete = false;
          window.localStorage.clear();
          localStorage.removeItem("heartBeat")
          window.location.reload()
          window.sessionStorage.clear();
          this.$router.push({
            path: `/signin`
          });
        }
      } catch (err) {
        //console.log("error msg", err.message);
        this.toast = true;
        this.errmsg = err.message;
      }
      this.showConfirmDelete = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/dashboard/_variables.scss"; // variables
@import "@/scss/dashboard/_header.scss"; // Header
.entity-container {
  background-color: white;
  z-index: 10;
  width: 300px;
  height: 150px;
  box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.15);
  border: solid 0.8px #c6c9c8;
  position: fixed;
  right: 5px;
  top: 50px;
  &::before {
    bottom: 100%;
    right: 10%;
    border: 0.8px solid #c6c9c8;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: transparent;
    border-bottom-color: $color-white;
    border-width: 21px 10px 21px 10px;
  }
  .entity-list {
    height: 70%;
    overflow-y: scroll;
    scrollbar-color: black;
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
      height: 50px;
      background-color: #666;
      border: 1px solid #eee;
      -webkit-border-radius: 6px;
    }
    .entity {
      padding: 20px;
      display: flex;
      align-items: center;
      &:not(:first-child) {
        background-color: #f9f9f9;
      }
      &:first-child {
        background-color: $color-white;
        padding: 30px;
      }
      &:not(:last-child) {
        border-bottom: solid 0.8px #c6c9c8;
      }
      .entity-img {
        height: 60px;
        width: 60px;
        border-radius: 50%;
        margin-right: 20px;
      }
      .entity-text {
        text-align: center;
      }
    }
  }
}
.links {
  cursor: pointer;
  .entity-container {
    display: none;
  }
  &:hover {
    .entity-container {
      display: block;
    }
  }
}
.btn-container2 {
  border-top: solid 0.8px #c6c9c8;
  position: absolute;
  width: 100%;
  bottom: 0px;
  display: flex;
  justify-content: center;
  padding: 15px;
  *:nth-child(n) {
    margin-right: 20px;
  }
  .btn-add-entity {
    background-color: $color-primary;
    color: $color-white;
    min-width: 70px;
    border-radius: 4px;
    height: 30px;
    font-size: 12px;
    padding: 5px 10px 5px 10px;
  }
  .btn-signout {
    font-size: 12px;
    padding: 5px;
    font-weight: bold;
    color: $color-secondary;
    cursor: pointer;
  }
}
.toolbar {
  background-color: white;
  border-bottom: 2px solid #ebebeb;
  position: fixed;
  z-index: 1;
}
.progress-bar {
  margin: 0 50px 0 150px;
  width: 60%;
}
.img-user-account {
  width: 33px;
  height: 33px;
  object-fit: contain;
}
.green-title {
  color: #34c0be;
  font-weight: bolder;
}

.toolbar-sub-text {
  color: #34c0be;
  font-weight: 500;
}

.right-align {
  margin-left: auto;
}

// Start PL-1973
@media only screen and (min-width: 1281px) and (max-width: 1440px) {
  .entity-container {
    right: 80px;
    z-index: 2;
    top: 50px;
  }
}

@media only screen and (max-width: 1280px) {
  .entity-container {
    right: 57px;
    top: 50px;
    z-index: 2;
  }
}
</style>
